<script lang="ts">
  import { type SearchResult } from '../../utils/search-types'
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  export interface SearchResultItemProps extends SearchResult {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  const props = defineProps<SearchResultItemProps>()
</script>
<template>
  <div
    :class="
      cn(
        'hover:bg-accent focus:bg-accent flex cursor-pointer items-center gap-3 px-4 py-2 text-sm',
        props.class
      )
    "
  >
    <gat-icon v-if="props.icon" :icon="props.icon" class="size-4" />
    <div class="flex flex-col">
      <div>{{ props.title }}</div>
      <div v-if="props.subTitle" class="text-soft text-xs">
        {{ props.subTitle }}
      </div>
    </div>
    <slot name="actions" />
  </div>
</template>
